module.exports = __webpack_public_path__ + "static/media/lichterkette_loop.ed034ca8.svg";